export default __webpack_public_path__ + "static/syphilis-box@2x-7fa3898aa7f5961cc7e5fedab893f2e7.png";